import { render, staticRenderFns } from "./ReservationManagement.vue?vue&type=template&id=544c2e5d&"
import script from "./ReservationManagement.vue?vue&type=script&lang=js&"
export * from "./ReservationManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReservationManagement.vue?vue&type=style&index=0&id=544c2e5d&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544c2e5d')) {
      api.createRecord('544c2e5d', component.options)
    } else {
      api.reload('544c2e5d', component.options)
    }
    module.hot.accept("./ReservationManagement.vue?vue&type=template&id=544c2e5d&", function () {
      api.rerender('544c2e5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ReservationManagement.vue"
export default component.exports